<template>
  <div class="sidebar-wrap">
    <div class="left-area" v-if="$store.getters.metadata.iconType === 'rectangle'">
      <img
        style="width: auto; height: 18px;"
        class="el-header__icon"
        :src="$store.getters.metadata.icon"
      />
      <span class="el-header__title">
        <span class="version-wrap">{{$store.getters.metadata.version}}</span>
      </span>
    </div>
    <div class="left-area" v-else>
      <img
        style="width: auto; height: 36px;"
        class="el-header__icon"
        :src="$store.getters.metadata.icon"
      />
      <span class="el-header__title">
        {{$store.getters.metadata.title.first}}
        <span
          class="version-wrap"
        >{{$store.getters.metadata.version}}</span>
      </span>
    </div>

    <div class="middle-area">
      <div class="middle-area__msglist">
        <breadcrumb />
      </div>
    </div>

    <div class="right-area">
      <el-tooltip effect="dark" content="快捷功能" placement="bottom">
        <img
          src="../../assets/images/quick.png"
          style="width: 25px;height: 25px;cursor: pointer;"
          @click="quickRouteTo"
        />
      </el-tooltip>
      <el-tooltip effect="dark" content="数据大屏" placement="bottom" v-show="!showVirtualData">
        <img
          src="../../assets/images/toDataScreen.png"
          style="width: 25px;height: 25px;cursor: pointer;margin-left: 22px;"
          @click="toDataScreen"
        />
      </el-tooltip>
      <!--  -->
      <el-tooltip effect="dark" content="设备数据大屏" placement="bottom" v-show="showVirtualData">
        <img
          src="../../assets/images/toDataScreen.png"
          style="width: 25px;height: 25px;cursor: pointer;margin-left: 22px;"
          @click="tobigScreen"
        />
      </el-tooltip>
      <!--  -->
      <el-badge
        :value="newMessage"
        style="margin-left: 22px;margin-top: 20px;"
        :hidden="newMessage==0"
      >
        <el-tooltip effect="dark" content="消息中心" placement="bottom">
          <i
            class="el-icon-bell"
            style="font-size: 24px;color: #000000;cursor: pointer;"
            @click="toMessageCenter"
          ></i>
        </el-tooltip>
      </el-badge>
      <fullscreen class="fullscreen" />
      <infodrop />
    </div>

    <el-dialog :visible.sync="myDialog" title="数据大屏" fullscreen @opened="afterOpen">
      <div style="width: 90%;margin-left: 5%;">
        <div style="margin-top: 10px;">
          <el-row :gutter="12">
            <el-col :span="8" v-if="isVender">
              <div>
                <el-card shadow="hover" style="background-color: #0099FB;color: white;">
                  <div slot="header">
                    <el-row>
                      <el-col :span="12">
                        <span>设备</span>
                      </el-col>
                      <el-col :span="12">
                        <el-select v-model="deviceSelect" @change="deviceChange">
                          <el-option value="0" label="今天"></el-option>
                          <el-option value="7" label="7天前"></el-option>
                          <el-option value="30" label="30天前"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="text item">
                    <div style="font-size: 24px;">
                      <span>{{deviceNum}}台</span>
                    </div>
                    <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                      <span>新增设备总数</span>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-col>
            <el-col :span="8" v-if="!isVender">
              <div>
                <el-card shadow="hover" style="background-color: #0099FB;color: white;">
                  <div slot="header">
                    <el-row>
                      <el-col :span="12">
                        <span>销量</span>
                      </el-col>
                      <el-col :span="12">
                        <el-select v-model="saleSelect" @change="saleChange">
                          <el-option value="0" label="今天"></el-option>
                          <el-option value="7" label="7天前"></el-option>
                          <el-option value="30" label="30天前"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="text item">
                    <div style="font-size: 24px;">
                      <span>{{saleNum}}元</span>
                    </div>
                    <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                      <span>新增销量</span>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <el-card shadow="hover" style="background-color: #52C41A;color: white;">
                  <div slot="header">
                    <el-row>
                      <el-col :span="12">
                        <span>开单</span>
                      </el-col>
                      <el-col :span="12">
                        <el-select v-model="userSelect" @change="userChange">
                          <el-option value="0" label="今天"></el-option>
                          <el-option value="7" label="7天前"></el-option>
                          <el-option value="30" label="30天前"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="text item">
                    <div style="font-size: 24px;">
                      <span>{{userNum}}人</span>
                    </div>
                    <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                      <span>新增客户</span>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <el-card shadow="hover" style="background-color: #F5222D;color: white;">
                  <div slot="header">
                    <el-row>
                      <el-col :span="12">
                        <span>钱包</span>
                      </el-col>
                      <el-col :span="12">
                        <el-select v-model="incomeSelect" @change="incomeChange">
                          <el-option value="0" label="今天"></el-option>
                          <el-option value="7" label="7天前"></el-option>
                          <el-option value="30" label="30天前"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="text item">
                    <div style="font-size: 24px;">
                      <span>{{money}}元</span>
                    </div>
                    <div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
                      <span>新增收益</span>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="margin-top: 25px;">
          <el-card shadow="hover">
            <div>
              <div>
                <el-row>
                  <el-col :span="12">
                    <span>钱包</span>
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="moneySelect" @change="moneySelectChange">
                      <el-option value="7" label="过去7天"></el-option>
                      <el-option value="30" label="过去30天"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
              <div>
                <div id="moneyDiv" style="margin-top: 10px;"></div>
              </div>
            </div>
          </el-card>
        </div>
        <div style="margin-top: 25px;" v-show="isVender">
          <el-card shadow="hover">
            <div>
              <span>设备地区分布(前五省份)</span>
            </div>
            <div>
              <div id="deviceLocalDiv" style="margin-top: 10px;width: 766px;"></div>
            </div>
          </el-card>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fullscreen from '@/components/fullscreen'
import notice from '@/components/notice'
import langselect from '@/components/langselect'
import infodrop from './NavbarInfoDrop'
import seamlessList from '@/components/seamlessList'
import breadcrumb from '@/components/breadcrumb'
import dayjs from 'dayjs'
import axios from 'axios'
import G2 from '@antv/g2';
import { View } from '@antv/data-set';

export default {
  name: 'Sidebar',
  components: {
    fullscreen,
    notice,
    infodrop,
    breadcrumb,
    'lang-select': langselect,
    'seamless-list': seamlessList
  },
  data () {
    return {
      system_version: this.$store.state.app.version,
      deviceNum: 0,
      userNum: 0,
      money: 0,
      saleNum: 0,
      moneyData: [],
      moneySelect: "7",
      deviceLocalData: [],
      newMessage: "0",
      isVender: false,
      myDialog: false,
      deviceSelect: "0",
      saleSelect: "0",
      userSelect: "0",
      incomeSelect: "0",
      moneyChart: null,
      deviceChart: null,
      isFirstInit: true,
      showVirtualData:false
    }
  },
  mounted () {
    if(this.$store.getters.appid==19987693){
      //滤中滤显示虚拟的数据大屏
      this.showVirtualData=true
    }
    if (!this.$store.getters.sidebar.sliderState) {
      this.$store.dispatch('setSliderState', 'full')
    }
    this.getWebSocketConnect();
    var thiz = this;
    axios.get(this.$store.getters.getApiValue + '/srsUser/getMyData.do').then(function (response) {
      var data = response.data;
      if (data.status == "200") {
        if (data.data.role == "4") {
          thiz.isVender = true;
        }
      } else {
        thiz.$message.error(data.message);
      }
    }).catch(function (error) {
      console.log(error);
      thiz.$message.error("系统异常,请与管理员联系!");
    });
  },
  methods: {
    deviceChange () {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsScreen/deviceIncrease.do', {
        params: {
          day: this.deviceSelect
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == "200") {
          thiz.deviceNum = data.data;
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        thiz.$message.error("系统异常，请与管理员联系!");
        console.log(error);
      });
    },
    saleChange () {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsScreen/sales.do', {
        params: {
          day: this.saleSelect
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == "200") {
          thiz.saleNum = data.data;
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        thiz.$message.error("系统异常，请与管理员联系!");
        console.log(error);
      });
    },
    userChange () {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsScreen/deviceAccount.do', {
        params: {
          day: this.userSelect
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == "200") {
          thiz.userNum = data.data;
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        thiz.$message.error("系统异常，请与管理员联系!");
        console.log(error);
      });
    },
    incomeChange () {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsScreen/income.do', {
        params: {
          day: this.incomeSelect
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == "200") {
          thiz.money = data.data;
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        thiz.$message.error("系统异常，请与管理员联系!");
        console.log(error);
      });
    },
    getWebSocketConnect () {
      //   var ishttps = 'https:' === document.location.protocol;
      //   var protocol = 'ws:';
      //   if (ishttps) {
      //     protocol = 'wss:'
      //   }
      // 	  var wsServer = `${protocol}//${window.location.host}/WebSocket.do`;
      // 	  var ws = new WebSocket(wsServer);
      // 	  var thiz = this;
      // 	  ws.onopen = function (evt) {
      // 	    console.log("已经建立连接");
      // 	  };
      // 	  ws.onmessage = function (evt) {
      // 	  	thiz.newMessage = evt.data;
      // 	    console.log(thiz.newMessage);
      // 	  };
      // 	  ws.onerror = function (evt) {
      // 	  	console.log(evt);
      // 	    console.log("产生异常");
      // 	  };
      // 	  ws.onclose = function (evt) {
      // 	  	console.log(evt);
      // 	    console.log("已经关闭连接");
      // 	  };
    },
    quickRouteTo () {
      this.$router.push({ path: '/shortCuts' });
    },
    toDataScreen () {
      this.$router.push({ path: '/datascreen' });
      // this.myDialog = true;
    },
    tobigScreen () {
      this.$router.push({ path: '/bigscreen' });
      // this.myDialog = true;
    },
    afterOpen () {
      this.initPage();
    },
    initPage () {
      var thiz = this;
      if (this.isVender) {
        this.deviceChange();
      } else {
        this.saleChange();
      }
      this.userChange();
      this.incomeChange();

      this.moneySelectChange();

      if (this.isVender) {
        axios.get(thiz.$store.getters.getApiValue + '/china-provinces.geo.json')
          .then(function (response) {
            var data = response.data;
            axios.get(thiz.$store.getters.getApiValue + '/srsScreen/deviceDistribution.do')
              .then(function (res) {
                var data1 = res.data;
                if (data1.status == "200") {
                  thiz.initDeviceLocalDiv(data, data1.data)
                } else {
                  thiz.$message.error(data.message);
                }
              }).catch(function (error) {
                thiz.$message.error("系统异常，请与管理员联系!");
                console.log(error);
              });
          }).catch(function (error) {
            console.log(error);
            thiz.$message.error("系统异常!请与管理员联系!");
          });
      }
    },
    moneySelectChange () {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsScreen/wallet.do', {
        params: {
          day: this.moneySelect
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == "200") {
          thiz.moneyData = data.data;
          thiz.initMoneyDiv();
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        thiz.$message.error("系统异常，请与管理员联系!");
        console.log(error);
      });
    },
    initMoneyDiv () {
      if (this.moneyChart == null) {
        this.moneyChart = new G2.Chart({
          container: 'moneyDiv',
          forceFit: true,
          height: 400,
          padding: [10, 120, 90, 100]
        });
        if (this.isVender) {
          this.moneyChart.source(this.moneyData, {
            income: {
              alias: "收益(元)",
              min: 0
            },
            account: {
              alias: "开单数(单)",
              min: 0
            }
          });
          this.moneyChart.legend({
            custom: true,
            allowAllCanceled: true,
            position: 'bottom-center',
            items: [{
              value: '开单数(单)',
              marker: {
                symbol: 'hyphen',
                stroke: '#3182bd',
                radius: 5,
                lineWidth: 3
              }
            }, {
              value: '收益(元)',
              marker: {
                symbol: 'hyphen',
                stroke: '#fdae6b',
                radius: 5,
                lineWidth: 3
              }
            }]
          });
        } else {
          this.moneyChart.source(this.moneyData, {
            income: {
              alias: "收益(元)",
              min: 0
            },
            total: {
              alias: "收益笔数(单)",
              min: 0
            }
          });
          this.moneyChart.legend({
            custom: true,
            allowAllCanceled: true,
            position: 'bottom-center',
            items: [{
              value: '收益笔数(单)',
              marker: {
                symbol: 'hyphen',
                stroke: '#3182bd',
                radius: 5,
                lineWidth: 3
              }
            }, {
              value: '收益(元)',
              marker: {
                symbol: 'hyphen',
                stroke: '#fdae6b',
                radius: 5,
                lineWidth: 3
              }
            }]
          });
        }
        this.moneyChart.axis('income', {
          grid: null,
          label: {
            textStyle: {
              fill: '#fdae6b'
            }
          }
        });
        if (this.isVender) {
          this.moneyChart.line().position('day*account').color('#3182bd').size(3).shape('smooth');
          this.moneyChart.point().position('day*account').color('#3182bd').size(3).shape('circle');
        } else {
          this.moneyChart.line().position('day*total').color('#3182bd').size(3).shape('smooth');
          this.moneyChart.point().position('day*total').color('#3182bd').size(3).shape('circle');
        }
        this.moneyChart.line().position('day*income').color('#fdae6b').size(3).shape('smooth');
        this.moneyChart.point().position('day*income').color('#fdae6b').size(3).shape('circle');
        this.moneyChart.render();
      } else {
        this.moneyChart.changeData(this.moneyData);
      }
    },
    initDeviceLocalDiv (mapdata, userData) {
      if (!this.isFirstInit) {
        this.deviceChart.destroy();
      }
      this.deviceChart = new G2.Chart({
        container: 'deviceLocalDiv',
        forceFit: true,
        height: 400,
        padding: [0, 200, 0, 10]
      });
      this.deviceChart.tooltip({
        showTitle: false
      });
      // 同步度量
      this.deviceChart.scale({
        longitude: {
          sync: true
        },
        latitude: {
          sync: true
        }
      });
      this.deviceChart.axis(false);
      this.deviceChart.legend('name', {
        position: 'right-center'
      });

      // 绘制世界地图背景
      var worldMap = new View('back').source(mapdata, {
        type: 'GeoJSON'
      });
      var worldMapView = this.deviceChart.view();
      worldMapView.source(worldMap);
      worldMapView.tooltip(false);
      worldMapView.polygon().position('longitude*latitude').style({
        fill: '#fff',
        stroke: '#ccc',
        lineWidth: 1
      });

      var userDv = new View().source(userData).transform({
        geoDataView: worldMap,
        field: 'name',
        type: 'geo.region',
        as: ['longitude', 'latitude']
      }).transform({
        type: 'map',
        callback: function callback (obj) {
          obj.trend = "第" + obj.rank + "名";
          obj.name = obj.name + "(销量:" + obj.value + "台)";
          obj.firstChild = "无";
          obj.secondChild = "无";
          obj.thirdChild = "无";
          for (var i = 0; i < obj.cityDistributionVOs.length; i++) {
            if (obj.cityDistributionVOs[i].rank == '1') {
              obj.firstChild = obj.cityDistributionVOs[i].name + "(销量:" + obj.cityDistributionVOs[i].value + "台)";
            }
            if (obj.cityDistributionVOs[i].rank == '2') {
              obj.secondChild = obj.cityDistributionVOs[i].name + "(销量:" + obj.cityDistributionVOs[i].value + "台)";
            }
            if (obj.cityDistributionVOs[i].rank == '3') {
              obj.thirdChild = obj.cityDistributionVOs[i].name + "(销量:" + obj.cityDistributionVOs[i].value + "台)";
            }
          }
          return obj;
        }
      });
      var userView = this.deviceChart.view();
      userView.source(userDv, {
        'trend': {
          alias: '销售排名'
        },
        'name': {
          alias: '销售前五省市'
        },
        firstChild: {
          alias: '销售第一城市'
        },
        secondChild: {
          alias: '销售第二城市'
        },
        thirdChild: {
          alias: '销售第三城市'
        }
      });
      userView.polygon().position('longitude*latitude').color('name', ['#0099FB', '#A0D911', '#FADB14', '#FA541C', '#EB2F96'])
        .tooltip('name*trend*firstChild*secondChild*thirdChild').animate({
          leave: {
            animation: 'fadeOut'
          }
        });
      this.deviceChart.render();
      this.isFirstInit = false;
    },
    toMessageCenter () {
      this.$router.push({ path: '/messageCenter' });
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/styl/variables.styl';

right-area-width = 250px;

.el-header {
  position: relative;

  .sidebar-wrap {
    display: flex;
  }

  .left-area {
    min-width: 240px;
    padding-left: 12px;
    box-sizing: border-box;
  }

  .middle-area {
    height: 60px;
    flex: 1;

    &__cgwrap {
      float: left;
      height: 100%;
      width: 60px;

      .category-icon {
        color: #515151;
        cursor: pointer;
        height: 100%;
        padding: 0 15px;
        transition: color 0.28s;

        &:hover {
          color: #41b883;
        }
      }
    }

    &__msglist {
      float: left;
      height: 60px;
      width: 'calc(%s - %s)' % (100% 60px);
      color: #808080;
      font-weight: 500;
      padding-left: 10px;
      box-sizing: border-box;
    }

    &:after {
      content: '';
      clear: both;
      display: block;
      width: 100%;
    }
  }

  .right-area {
    {flex-center};
    padding-right: 16px;
    height: 60px;
    min-width: right-area-width;

    .fullscreen {
      height: 100%;
      padding: 0 22px;
    }

    .lang {
      height: 60px;
    }
  }

  &__title, &__icon {
    vertical-align: middle;
  }

  &__title {
    font-size: 20px;
    font-weight: bold;
    color: main-color;

    .subtitle {
      color: sub-color;
    }

    .version-wrap {
      background: #eaeaea;
      padding: 3px 8px;
      font-size: 12px;
      margin-left: 8px;
      border-radius: 3px;
      vertical-align: top;
    }
  }
}
</style>

<style>
.fullDivClass {
  display: none;
  height: 100%;
  width: 100%;
  background-color: #efeff7;
  color: #000000;
  position: fixed;
  z-index: 999;
  text-align: center;
}
.fullItemClass {
  cursor: pointer;
  font-size: 18px;
  margin-top: 25px;
}
</style>
